import { useEffect, useRef, useState } from 'react'

export const NEEDLE_ANIMATION_DURATION_MS = 1200
export const NEEDLE_ANIMATION_START_DELAY_MS = 500

const easeOutCubic = (t) => 1 - (1 - t) ** 3

export default function useAnimatedNumber(
  targetValue,
  duration = NEEDLE_ANIMATION_DURATION_MS,
  delay = NEEDLE_ANIMATION_START_DELAY_MS
) {
  const [animatedValue, setAnimatedValue] = useState(0)
  const currentValueRef = useRef(0)

  useEffect(() => {
    const startValue = currentValueRef.current
    const delta = targetValue - startValue
    let startTimestamp = null
    let frameId = null
    let timeoutId = null

    const tick = (timestamp) => {
      if (startTimestamp === null) startTimestamp = timestamp
      const progress = Math.min((timestamp - startTimestamp) / duration, 1)
      const nextValue = startValue + delta * easeOutCubic(progress)
      currentValueRef.current = nextValue
      setAnimatedValue(nextValue)
      if (progress < 1) {
        frameId = requestAnimationFrame(tick)
      }
    }

    timeoutId = setTimeout(() => {
      frameId = requestAnimationFrame(tick)
    }, delay)

    return () => {
      if (timeoutId !== null) clearTimeout(timeoutId)
      if (frameId !== null) cancelAnimationFrame(frameId)
    }
  }, [targetValue, duration, delay])

  return animatedValue
}
